import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "getting-started" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1>Custom Layer</h1><p><b>Vue3-Charts</b> is build to be highly customizable.</p><p> The library comes with some built-in layers (<code>Line</code>, <code>Bar</code>, <code>Area</code> etc...) but you can easly write your own layers using the power of Vue3 <a href=\"https://v3.vuejs.org/api/composition-api.html\">composition api</a></p><h2>Labels Layer</h2><p> To demonstrate how to build a custom layer we will create a layer called <code>Labels</code></p><p> The purpose of the layer is to display a label on the chart for each data point. Let&#39;s start with a simple line chart example. </p>", 6)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " As you can see in this example, it is very hard to see the values for each data point, so our layer will display a text with the value for each point. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" To create our layer we will use the "),
  /*#__PURE__*/_createElementVNode("code", null, "usePoints"),
  /*#__PURE__*/_createTextVNode(" hook provided by Vue3-Charts. ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " The hook will do all the job for us (mapping the data) and will give us a list of points that we can use to draw whatever we want, in our case we will simply draw a text. ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "Here is the code for our layer:", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "And after we add this layer to our chart we get this result:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" As you can see this is pretty easy and you can draw whatever you want. You can check the code for our built-in layers to learn more "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://github.com/ghalex/vue3-charts/blob/main/src/components/Line/index.vue"
  }, "Line"),
  /*#__PURE__*/_createTextVNode(", "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://github.com/ghalex/vue3-charts/blob/main/src/components/Bar/index.vue"
  }, "Bar"),
  /*#__PURE__*/_createTextVNode(", "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://github.com/ghalex/vue3-charts/blob/main/src/components/Marker/index.vue"
  }, "Marker")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomLayerChart = _resolveComponent("CustomLayerChart")!
  const _component_ChartBlock = _resolveComponent("ChartBlock")!
  const _component_CodeBlock = _resolveComponent("CodeBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ChartBlock, {
      chartCode: _ctx.code.chartCode,
      dataCode: _ctx.code.dataCode
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CustomLayerChart)
      ]),
      _: 1
    }, 8, ["chartCode", "dataCode"]),
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _createVNode(_component_CodeBlock, {
      code: _ctx.code.customLayer
    }, null, 8, ["code"]),
    _hoisted_12,
    _createVNode(_component_ChartBlock, {
      chartCode: _ctx.code.chartCodeLabels,
      dataCode: _ctx.code.dataCode
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CustomLayerChart, { showLabels: true })
      ]),
      _: 1
    }, 8, ["chartCode", "dataCode"]),
    _hoisted_13
  ]))
}